module.exports = __webpack_public_path__ + "static/media/icon-calendar.ad1c12b3.svg";